import { render } from "./CollectionList.vue?vue&type=template&id=2e444dfc"
import script from "./CollectionList.vue?vue&type=script&lang=ts"
export * from "./CollectionList.vue?vue&type=script&lang=ts"
script.render = render

export default script